<template>
  <div class="c-table" ref="landtable">
    <!-- <Spin size="large" fix v-if="loading"></Spin> -->
    <el-table class="common-el-table-styles" stripe border v-loading="loading" :data="data" :height="height">
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :show-overflow-tooltip="col.overflow"
        :min-width="col.width"
        :align="col.align"
      >
        <template slot-scope="scope">
          <div v-if="col.key === 'imageAddr'" @click="preClick(scope.row)">
            <el-image class="m-view-image" :src="scope.row[col.key]" fit="contain"></el-image>
          </div>
          <div v-else-if="col.key === 'control'" class="m-control">
            <el-button type="text" size="small" @click="refreshClick(scope.row)">刷新CDN</el-button>
            <el-button type="text" size="small" @click="editClick(scope.row)" :disabled="!scope.row.isUpdate">修改</el-button>
            <div>
              <el-button
                type="text"
                size="small"
                class="c-control-margin"
                v-clipboard:copy="scope.row.pageAddr"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
                >地址链接</el-button
              >
              <el-button type="text" size="small" @click="copyClick(scope.row)">复制</el-button>
            </div>
          </div>
          <span v-else-if="col.key === 'urlType'">{{ scope.row[col.key] | urlType }}</span>
          <span v-else-if="col.key === 'upTime'">{{ scope.row[col.key] | datetimeToMin }}</span>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  name: 'landTable',
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },
    columns: {
      type: Array
    },
    height: {
      type: Number
    }
  },
  methods: {
    editClick(row) {
      const { pageId } = row
      window.open(`/pageland/pagelayout?id=${pageId}&t=edit`, '_blank')
    },
    copyClick(row) {
      const { pageId } = row
      window.open(`/pageland/pagelayout?id=${pageId}`, '_blank')
    },
    refreshClick(row) {
      const { pageId } = row
      this.$emit('on-cdn', pageId)
    },
    preClick(row) {
      const { pageAddr, pageName } = row
      this.$emit('on-preview', { url: pageAddr, title: pageName })
    },
    onCopy() {
      this.$Message.success('复制成功！')
    },
    onError() {
      this.$Message.warning('剪切板禁止访问')
    }
  },

  filters: {
    urlType(cell) {
      if (cell === 1) return '单端自动生成'
      else if (cell === 2) return '双端手动填写'
      else return ''
    }
  }
}
</script>
<style lang="scss" scoped>
.c-table {
  height: calc(100% - 32px);
  background-color: #fff;

  .el-table {
    height: 100%;

    .m-control {
      button {
        padding: 2px 0;
      }
    }
  }

  .c-control-margin {
    margin: 0;
    padding: 0 3px;
  }

  .m-view-image {
    width: 150px;
    height: 100px;
  }
}
</style>
